import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a743a06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "detail" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "detail" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "detail" }
const _hoisted_8 = { class: "tips" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('预约方式')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('致电 +852 3974-0254 预约')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('（早上10时至晚上7时）')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('预约流程')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('1. 致电预约时请示意您已经是Fusion Bank客户')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t(
              '2.到场试驾前，Tesla职员会要求您出示Fusion Bank app的个人账号页以证明您已是Fusion Bank 客户。如到场时未成为Fusion Bank 客户，建议您即场下载Fusion Bank app并且开户，过程最快可于5分钟内完成 !',
            )), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(
          '*Tesla提供的有关此推广计划的产品及/或服务并非由本行所提供。因此，有关Tesla、其员工、其人员及其代理人于推广计划提供的各项产品/服务的各方面，包括但不只限于Tesla所提供的产品及/或其服务的质素、供应量、产品及/或其服务说明、任何虚假的交易说明、虚假陈述、错误声明、遗漏、未经授权的陈述、与此推广相关或就提供此推广下的产品及/或服务的不公平贸易惯例或行为，本行均毋须负上任何责任。',
        )), 1),
    _hoisted_9
  ]))
}